// Elle ölçüm girişi (2026-10-05) — kilo ve mezura ölçüleri. Tartısı olmayan
// diyetisyen/klinik personeli içindir; kayıt "manual" kaynaklı ölçüm olarak düşer.

import React, { useEffect, useState } from "react";
import { Box, Drawer } from "@mui/material";
import { Straighten as TapeIcon } from "@mui/icons-material";
import { DrawerHeader, DrawerFooter, FormTextField, ChoiceChipGroup, FormDatePicker } from "../../../atoms";
import DrawerField from "../../../molecules/DrawerField";
import { useClinicTheme } from "../../../../theme";
import { useAlert } from "../../../../context/AlertProvider";
import { useCreateManualMeasurementMutation } from "../../../../store/secretaryApi";

const TYPES = [
  { value: "body_circumference", label: "Mezura ölçüleri" },
  { value: "weight", label: "Kilo" },
];

export const CIRCUMFERENCE_FIELDS = [
  { key: "waist", label: "Bel" },
  { key: "hip", label: "Kalça" },
  { key: "chest", label: "Göğüs" },
  { key: "arm", label: "Kol" },
  { key: "thigh", label: "Bacak (uyluk)" },
  { key: "neck", label: "Boyun" },
];

const todayYmd = () => new Date().toISOString().slice(0, 10);

export default function ManualMeasurementDrawer({ open, onClose, patientId, token, onSaved }) {
  const { palette } = useClinicTheme();
  const { showSuccess, showError } = useAlert();
  const [createManual, { isLoading }] = useCreateManualMeasurementMutation();
  const [type, setType] = useState("body_circumference");
  const [values, setValues] = useState({});
  const [date, setDate] = useState(todayYmd());

  useEffect(() => {
    if (open) {
      setValues({});
      setDate(todayYmd());
    }
  }, [open]);

  const fields = type === "weight" ? [{ key: "weight", label: "Kilo" }] : CIRCUMFERENCE_FIELDS;
  const unit = type === "weight" ? "kg" : "cm";
  const filled = fields.filter((f) => Number(String(values[f.key] || "").replace(",", ".")) > 0);

  const handleSave = async () => {
    try {
      await createManual({
        token,
        patientId,
        metricType: type,
        takenAt: date ? new Date(`${date}T12:00:00`).toISOString() : undefined,
        values: filled.map((f) => ({ key: f.key, value: Number(String(values[f.key]).replace(",", ".")), unit })),
      }).unwrap();
      showSuccess("Ölçüm kaydedildi.");
      onSaved?.();
      onClose?.();
    } catch (err) {
      showError(err?.data?.message || "Ölçüm kaydedilemedi.");
    }
  };

  return (
    <Drawer anchor="right" open={open} onClose={onClose} PaperProps={{ sx: { width: { xs: "100%", sm: 460 } } }}>
      <Box sx={{ display: "flex", flexDirection: "column", height: "100%" }}>
        <DrawerHeader icon={<TapeIcon />} title="Elle ölçüm gir" subtitle="Kilo veya mezura ölçüleri" onClose={onClose} />
        <Box sx={{ flex: 1, overflowY: "auto", px: 3, py: 2, display: "grid", gridTemplateColumns: "1fr 1fr", gap: 2, alignContent: "start" }}>
          <DrawerField label="Ölçüm" fullWidth>
            <ChoiceChipGroup options={TYPES} value={type} onChange={setType} palette={palette} ariaLabel="Ölçüm tipi" />
          </DrawerField>
          <DrawerField label="Tarih" fullWidth>
            <FormDatePicker palette={palette} value={date} onChange={setDate} sx={{ maxWidth: 200 }} />
          </DrawerField>
          {fields.map((f) => (
            <DrawerField key={f.key} label={`${f.label} (${unit})`}>
              <FormTextField
                palette={palette}
                variant="standard"
                size="small"
                fullWidth
                inputMode="decimal"
                value={values[f.key] || ""}
                onChange={(e) => setValues((v) => ({ ...v, [f.key]: e.target.value }))}
              />
            </DrawerField>
          ))}
        </Box>
        <DrawerFooter onCancel={onClose} onSubmit={handleSave} loading={isLoading} disabled={filled.length === 0} />
      </Box>
    </Drawer>
  );
}
